import React from 'react';
import styled from 'styled-components';
import useUserData from 'hooks/useUserData';
import Card from 'features/shared/ui/Card';
import { SidebarCardTitle } from '../../OlympiadsListStyled';

const CardWrap = styled(Card).attrs({ $shadow: true })`
  display: flex;
  flex-direction: column;
  color: var(--font-color);
  font-size: 14px;
  line-height: 20px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const ContactLink = styled.a<{ $isSupport?: boolean }>`
  display: block;
  color: ${({ $isSupport }) => ($isSupport ? 'var(--black-60)' : 'var(--font-color)')};
  white-space: ${({ $isSupport }) => ($isSupport ? 'nowrap' : 'normal')};

  &:hover,
  &:focus {
    color: var(--primary-base);
  }
`;

const SupportWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 16px;
  font-size: 12px;
  line-height: 16px;
`;

const OlympiadsManagerCard = () => {
  const manager = useUserData();

  if (!manager || !manager.grManager) return null;

  return (
    <CardWrap data-testid="olympiads-manager-card">
      <SidebarCardTitle>Ваш менеджер</SidebarCardTitle>
      
      <Content>
        <div>{manager.grManager.full_name}</div>
        <ContactLink href={`mailto:${manager.grManager.email}`}>{manager.grManager.email}</ContactLink>
        {manager.grManager.phone && (
          <ContactLink href={`tel:${manager.grManager.phone.replace(/[^0-9+]/g, '')}`}>
            {manager.grManager.phone}
          </ContactLink>
        )}
      </Content>

      <SupportWrap>
        <ContactLink $isSupport href="mailto:info@uchi.ru">
          info@uchi.ru
        </ContactLink>
        <ContactLink $isSupport href="tel:88005003072">
          8 800 500-30-72
        </ContactLink>
      </SupportWrap>
    </CardWrap>
  );
};

export default OlympiadsManagerCard;